import { Injectable, inject } from '@angular/core';
import {ApiCallsService} from './api-calls.service';

@Injectable({
  providedIn: 'root'
})
export class TitleServiceService {
  private apiCalls = inject(ApiCallsService);


  getTile() {
    return this.apiCalls.getData({type: 'title'});
  }

  saveTitle(data) {
    if (data.id) {
      this.apiCalls.updateData(data).subscribe(
          response => {
            console.log('saved data ', data);
          },
          errors => { console.log(errors); }
      );
    } else {
      this.apiCalls.setData(data).subscribe(
          response => {
            console.log('saved data ', data);
          },
          errors => { console.log(errors); }
      );
    }
  }
}
